import { render, staticRenderFns } from "./update-register-item-ax.vue?vue&type=template&id=33b70f3e&"
import script from "./update-register-item-ax.vue?vue&type=script&lang=js&"
export * from "./update-register-item-ax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports